// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=K2D:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* // Lab page */

.swal-modal {
  background-color: #171717;
  color: #777 !important;
}

.swal-icon--success__hide-corners {
  /* background: none; */
  display: none;
  /* opacity: 0; */
}

.swal-icon--success:after,
.swal-icon--success:before {
  position: none;
  width: 0;
  height: 0;
}

.swal-icon--success:after,
.swal-icon--success:before {
  background: #171717;
}

.swal-title {
  color: #f18f3c !important;
}
.swal-text {
  color: #777 !important;
}
.swal-button {
  background-color: #fff;
  color: #777;
}
.swal-button:not([disabled]):hover {
  background-color: #fff;
  color: #777;
}

.labIcon {
  cursor: 'pointer' !important;
}

.btnLogin {
  font-weight: 500;
  font-size: 1em;
  text-transform: uppercase;
  padding: 18px 50px;
  background: transparent;
  border: none !important;
  transition: 0.4s all cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  z-index: 2;
}

.passwordField {
}
.authFormWrap .form-group .form-control {
  color: #f18f3c !important;
}

.btnLogin:after {
  content: '';
  position: absolute;
  transition: 0.4s all cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.btn-4 {
  color: #0e0e16;
  border: 2px solid #0e0e16;
}
.btn-4:after {
  border: solid #0e0e16;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  transform: rotate(-45deg) translateY(-48%);
  top: 48%;
  right: 25%;
  opacity: 0;
  visibility: hidden;
  z-index: -1;
}
.btn-4:hover {
  border: 2px solid transparent;
  color: black;
}
.btn-4:hover:after {
  opacity: 1;
  visibility: visible;
  right: 15%;
}
.loginBtnText {
  color: rgb(84, 76, 76);
}
.loginBtnText:hover {
  transition: all 0.5s;
  color: black;
}

.companyLogo {
  width: 12rem !important;
}

.card-title {
  /* text-align: center; */
  /* font-size: 3rem !important; */
}
.percent {
  font-size: 3rem !important;
}

.btn-group-toggle {
  padding-top: 10px;
  height: 40px;
}
.group-by-wrap {
  padding-top: -51px !important;
}

.card-title {
  display: flex;
  justify-content: space-between;
  flex: none;
  padding: 1rem;
}

.loginForm {
  font-family: 'Poppins', sans-serif;
}

.sidebarMenuInner li {
  overflow: hidden !important;
}

.designLabSidebarWrapper .designLabSidebar {
  margin-left: 0 !important;
}

.zoom-slider-wrap input {
  margin-left: 32px;
}

.drawing-board-container {
  height: 75vh !important;
}

.jtk-overlay * {
  width: 1rem !important;
  max-width: 1rem !important;
}

.sidebar-wrapper .sidebarMenuInner li {
  padding-right: 0 !important;
}

.jtk-overlay {
  border-radius: 70% !important;
  padding: 1rem !important;
  font-size: x-small !important;
}

.chatOverlay {
  cursor: pointer;
}

.terminalContainer {
  opacity: 0.5;
}

.userCardReset {
  padding: 0 !important;
  margin: 0 !important;
}

/* .drawing-board-sketchpad-canvas {
  height: 300px !important;
}

.drawing-board-sketchpad-container {
  height: 300px !important;
}
.ant-layout-content {
  max-height: 300px !important ;
} */

/* .pathEmu_dropdown__image {
  background-image: url('https://em-content.zobj.net/thumbs/160/apple/354/wireless_1f6dc.png');
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 5px;
} */

.teams-card {
  transition: all 800ms cubic-bezier(0.19, 1, 0.22, 1);
  background: none !important;
  border: 1px solid #222322;
  /* transition: all 0.3s; */
}

.teams-card:hover {
  transform: scale(1.05);
  transition: all 800ms cubic-bezier(0.19, 1, 0.22, 1);
}
`, "",{"version":3,"sources":["webpack://./src/modules/public/pages/custom.css"],"names":[],"mappings":"AAEA,gBAAgB;;AAEhB;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,yDAAyD;EACzD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;AACA;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,0CAA0C;EAC1C,QAAQ;EACR,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;;;;;;;;GASG;;AAEH;;;;;;GAMG;;AAEH;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,oDAAoD;AACtD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=K2D:wght@400;700&display=swap');\r\n/* // Lab page */\r\n\r\n.swal-modal {\r\n  background-color: #171717;\r\n  color: #777 !important;\r\n}\r\n\r\n.swal-icon--success__hide-corners {\r\n  /* background: none; */\r\n  display: none;\r\n  /* opacity: 0; */\r\n}\r\n\r\n.swal-icon--success:after,\r\n.swal-icon--success:before {\r\n  position: none;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.swal-icon--success:after,\r\n.swal-icon--success:before {\r\n  background: #171717;\r\n}\r\n\r\n.swal-title {\r\n  color: #f18f3c !important;\r\n}\r\n.swal-text {\r\n  color: #777 !important;\r\n}\r\n.swal-button {\r\n  background-color: #fff;\r\n  color: #777;\r\n}\r\n.swal-button:not([disabled]):hover {\r\n  background-color: #fff;\r\n  color: #777;\r\n}\r\n\r\n.labIcon {\r\n  cursor: 'pointer' !important;\r\n}\r\n\r\n.btnLogin {\r\n  font-weight: 500;\r\n  font-size: 1em;\r\n  text-transform: uppercase;\r\n  padding: 18px 50px;\r\n  background: transparent;\r\n  border: none !important;\r\n  transition: 0.4s all cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.passwordField {\r\n}\r\n.authFormWrap .form-group .form-control {\r\n  color: #f18f3c !important;\r\n}\r\n\r\n.btnLogin:after {\r\n  content: '';\r\n  position: absolute;\r\n  transition: 0.4s all cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n.btn-4 {\r\n  color: #0e0e16;\r\n  border: 2px solid #0e0e16;\r\n}\r\n.btn-4:after {\r\n  border: solid #0e0e16;\r\n  border-width: 0 2px 2px 0;\r\n  display: inline-block;\r\n  padding: 4px;\r\n  transform: rotate(-45deg) translateY(-48%);\r\n  top: 48%;\r\n  right: 25%;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  z-index: -1;\r\n}\r\n.btn-4:hover {\r\n  border: 2px solid transparent;\r\n  color: black;\r\n}\r\n.btn-4:hover:after {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  right: 15%;\r\n}\r\n.loginBtnText {\r\n  color: rgb(84, 76, 76);\r\n}\r\n.loginBtnText:hover {\r\n  transition: all 0.5s;\r\n  color: black;\r\n}\r\n\r\n.companyLogo {\r\n  width: 12rem !important;\r\n}\r\n\r\n.card-title {\r\n  /* text-align: center; */\r\n  /* font-size: 3rem !important; */\r\n}\r\n.percent {\r\n  font-size: 3rem !important;\r\n}\r\n\r\n.btn-group-toggle {\r\n  padding-top: 10px;\r\n  height: 40px;\r\n}\r\n.group-by-wrap {\r\n  padding-top: -51px !important;\r\n}\r\n\r\n.card-title {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  flex: none;\r\n  padding: 1rem;\r\n}\r\n\r\n.loginForm {\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\n.sidebarMenuInner li {\r\n  overflow: hidden !important;\r\n}\r\n\r\n.designLabSidebarWrapper .designLabSidebar {\r\n  margin-left: 0 !important;\r\n}\r\n\r\n.zoom-slider-wrap input {\r\n  margin-left: 32px;\r\n}\r\n\r\n.drawing-board-container {\r\n  height: 75vh !important;\r\n}\r\n\r\n.jtk-overlay * {\r\n  width: 1rem !important;\r\n  max-width: 1rem !important;\r\n}\r\n\r\n.sidebar-wrapper .sidebarMenuInner li {\r\n  padding-right: 0 !important;\r\n}\r\n\r\n.jtk-overlay {\r\n  border-radius: 70% !important;\r\n  padding: 1rem !important;\r\n  font-size: x-small !important;\r\n}\r\n\r\n.chatOverlay {\r\n  cursor: pointer;\r\n}\r\n\r\n.terminalContainer {\r\n  opacity: 0.5;\r\n}\r\n\r\n.userCardReset {\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n/* .drawing-board-sketchpad-canvas {\r\n  height: 300px !important;\r\n}\r\n\r\n.drawing-board-sketchpad-container {\r\n  height: 300px !important;\r\n}\r\n.ant-layout-content {\r\n  max-height: 300px !important ;\r\n} */\r\n\r\n/* .pathEmu_dropdown__image {\r\n  background-image: url('https://em-content.zobj.net/thumbs/160/apple/354/wireless_1f6dc.png');\r\n  display: inline-block;\r\n  width: 24px;\r\n  height: 24px;\r\n  margin-right: 5px;\r\n} */\r\n\r\n.teams-card {\r\n  transition: all 800ms cubic-bezier(0.19, 1, 0.22, 1);\r\n  background: none !important;\r\n  border: 1px solid #222322;\r\n  /* transition: all 0.3s; */\r\n}\r\n\r\n.teams-card:hover {\r\n  transform: scale(1.05);\r\n  transition: all 800ms cubic-bezier(0.19, 1, 0.22, 1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
